export const viewportOptions = ["Entire Region", "San Francisco", "Berkeley", "Oakland"];

export const modelTypeOptions = ["block", "parcel", "zone"];
